import { Routes } from '@angular/router';
import { provideStates } from '@ngxs/store';
import { MsalGuard } from '@azure/msal-angular';

import { MapComponent } from './components/map/map.component';
import { ReportsComponent } from './components/reports/reports.component';
import { ReportsState } from './shared/state/reports/reports.state';
import { SalDataComponent } from './components/sal-data/sal-data.component';
import { SalDataState } from './shared/state/sal-data/sal-data.state';
import { SearchResultsComponent } from './components/search-results/search-results.component';
import { SearchResultsState } from './shared/state/search-results/search-results.state';
import { TenantGuard } from './shared/guards/tenant.guard';
import { NewsComponent } from './components/news/news.component';
import { NewsState } from './shared/state/news/news.state';

export const routes: Routes = [
    {
        path: 'unauthorized',
        loadComponent: () =>
            import('./auth/components/unauthorized/unauthorized.component').then(c => c.UnauthorizedComponent)
    },
    {
        path: 'home',
        redirectTo: 'map',
        pathMatch: 'full'
    },
    {
        path: 'reports',
        component: ReportsComponent,
        data: {},
        providers: [provideStates([ReportsState])],
        canActivate: [MsalGuard, TenantGuard]
    },
    {
        path: 'data',
        component: SalDataComponent,
        data: {},
        providers: [provideStates([SalDataState])],
        canActivate: [MsalGuard, TenantGuard]
    },
    {
        path: 'map',
        component: MapComponent,
        data: {},
        canActivate: [MsalGuard, TenantGuard]
    },
    {
        path: 'location/detail/:id',
        component: MapComponent,
        data: { view: 'location' },
        canActivate: [MsalGuard, TenantGuard]
    },
    {
        path: 'location/detail/:id/person/:cn',
        component: MapComponent,
        data: { view: 'location' },
        canActivate: [MsalGuard, TenantGuard]
    },
    {
        path: 'country/detail/:id',
        component: MapComponent,
        data: { view: 'country' },
        canActivate: [MsalGuard, TenantGuard]
    },
    {
        path: 'results',
        component: SearchResultsComponent,
        data: {},
        providers: [provideStates([SearchResultsState])],
        canActivate: [MsalGuard, TenantGuard]
    },
    {
        path: 'news',
        component: NewsComponent,
        data: {},
        providers: [provideStates([NewsState])],
        canActivate: [MsalGuard, TenantGuard]
    },
    { path: '403', redirectTo: '/unauthorized', pathMatch: 'full' },
    { path: '', redirectTo: '/map', pathMatch: 'full' }
];
